import { ContentStatus, Continent } from "@prisma/client";
import { z } from "zod";

export const CreateContentValidation = z.object({
  id: z.string().optional(),
  title: z.string().min(1, {
    message: "Required",
  }),
  contentTypeId: z.string().min(1, {
    message: "Required",
  }),
  langId: z.string().min(2, {
    message: "Required",
  }),
  content: z.string().optional(),
  bannerId: z.string().optional(),
  bannerDesc: z.string().optional(),
  thumbnail: z.string().optional(),
  desc: z.string().optional(),
  tags: z.string().array().optional(),
  activities: z.string().array().optional(),
  status: z.nativeEnum(ContentStatus).optional(),
});

export const UpdateContentValidation = z.object({
  oldContentId: z.string(),
  contentId: z.string(),
  content: z
    .string()
    .min(1, {
      message: "Required",
    })
    .optional(),
  title: z
    .string()
    .min(1, {
      message: "Required",
    })
    .optional(),
  desc: z
    .string()
    .min(1, {
      message: "Required",
    })
    .optional(),
  bannerImg: z.string().optional(),
  bannerDesc: z.string().optional(),
  thumbnail: z.string().optional(),
  tags: z.string().array().optional(),
  activities: z.string().array().optional(),
  status: z.nativeEnum(ContentStatus),
});

export const CreateContentFormValidation = z.object({
  id: z.string().min(1, {
    message: "Required",
  }),
  title: z.string().min(1, {
    message: "Required",
  }),
  contentTypeId: z.string().min(1, {
    message: "Required",
  }),
  langId: z.string().min(2, {
    message: "Required",
  }),
  content: z.string().optional(),
  bannerId: z.string().optional(),
  bannerDesc: z.string().optional(),
  desc: z.string().optional(),
  tags: z.string().optional(),
  activities: z.string().optional(),
});

export const UpdateContentFormValidation = z.object({
  contentId: z.string(),
  content: z
    .string()
    .min(1, {
      message: "Required",
    })
    .optional(),
  title: z.string().min(1, {
    message: "Required",
  }),
  desc: z.string().optional(),
  bannerId: z.string().optional(),
  bannerDesc: z.string().optional(),
  tags: z.string().optional(),
  activities: z.string().optional(),
  status: z.nativeEnum(ContentStatus),
});

export const FnqValidation = z.object({
  question: z.string(),
  answer: z.string(),
});

export const JourneyFormAirportTransferValidation = z.object({
  to: z.string(),
  toAddress: z.string(),
  toLatitude: z.number(),
  toLongitude: z.number(),
});

export const AirportTransferCommentValidation = z.object({
  comment: z.string(),
  username: z.string(),
  country: z.string(),
  avatar: z.string().optional(),
});

export const AirportTransferCTAValidation = z.object({
  title: z.string(),
  link: z.string(),
});

export const AirportTransferWhyUsValidation = z.object({
  title: z.string(),
  desc: z.string(),
});

export const CreateATPostValidation = z.object({
  title: z.string(),
  desc: z.string(),
  thumbnail: z.string().optional(),
  continent: z.nativeEnum(Continent),
  fnqs: z.array(FnqValidation).optional(),
  journey: z.array(JourneyFormAirportTransferValidation).optional(),
  content: CreateContentValidation.optional(),
  comments: z.array(AirportTransferCommentValidation).optional(),
  cta: z.array(AirportTransferCTAValidation).optional(),
  whyUs: z.array(AirportTransferWhyUsValidation).optional(),
  name: z.string().optional(),
  longitude: z.number().optional(),
  latitude: z.number().optional(),
  formattedAddress: z.string().optional(),
  placeId: z.string().optional(),
});

export const UpdateATPostValidation = z.object({
  id: z.string(),
  title: z.string(),
  desc: z.string(),
  thumbnail: z.string().optional(),
  fnqs: z.array(FnqValidation).optional(),
  journey: z.array(JourneyFormAirportTransferValidation).optional(),
  content: UpdateContentValidation.optional(),
  comments: z.array(AirportTransferCommentValidation).optional(),
  cta: z.array(AirportTransferCTAValidation).optional(),
  whyUs: z.array(AirportTransferWhyUsValidation).optional(),
  longitude: z.number().optional(),
  latitude: z.number().optional(),
  name: z.string().optional(),
  formattedAddress: z.string().optional(),
  placeId: z.string().optional(),
});

export const createContentReviewValidation = z.object({
  textContentId: z.string(),
  review: z.string().min(1, {
    message: "Please enter a review!",
  }),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  email: z.string().email({
    message: "Please enter your email so we can identify you!",
  }),
})

export const deleteContentReviewValidation = z.object({
  textContentId: z.string(),
  reviewId: z.string(),
})